<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Prelim-head" id="_idParaDest-5"><a id="_idTextAnchor004"></a>The Secret of Hideaway Cove</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781528954297_EPUB-5.vue?05750d3c